export default function(value:number): string{
  return value.toLocaleString('id-ID')
}
